import { ReactNode, useEffect, useRef, useState } from 'react';
import MaskedInput from 'react-text-mask';
import { useIntl } from 'react-intl';

import { FormItemProps } from 'antd';
import removeMask, { removeMaskFromEvent } from '@/utils/mask/removeMask';
import { ncmMask } from '@/utils/mask/commonMasks';
import { maskFieldValidator } from '@/utils/mask';

import FloatingFormItem from '../FloatingFormItem';

interface Props extends FormItemProps {
  onChange: () => void;
  label?: ReactNode;
  fieldName?: string;
  requiredRuleTextId?: string;
  lengthRuleTextId?: string;
  required?: boolean;
}

const NcmFormField = ({
  initialValue,
  onChange,
  label = 'NCM',
  fieldName = 'ncm',
  requiredRuleTextId = 'commons.form.errors.requiredNcm',
  lengthRuleTextId = 'commons.form.errors.invalidNcm',
  required = true,
}: Props) => {
  const intl = useIntl();

  const maskRef = useRef<MaskedInput>(null);
  const [mask, setMask] = useState(ncmMask.ncmMask8);

  useEffect(() => {
    if (maskRef.current) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      maskRef.current.inputElement.onblur = (ev: any) => {
        const value = removeMask(ev.target.value);
        if (value.length >= 0 && value.length <= 5) {
          setMask(ncmMask.ncmMask4);
        } else if (value.length > 5 && value.length <= 7) {
          setMask(ncmMask.ncmMask6);
        } else {
          setMask(ncmMask.ncmMask8);
        }
      };

      maskRef.current.inputElement.onfocus = () => {
        setMask(ncmMask.ncmMask8);
      };
    }
  }, [maskRef]);

  const rulesRequired = required
    ? [
        {
          required: true,
          message: intl.formatMessage({ id: requiredRuleTextId }),
        },
      ]
    : [];

  const rules = [
    ...rulesRequired,
    {
      min: 4,
      max: 8,
      validator: maskFieldValidator,
      message: intl.formatMessage({ id: lengthRuleTextId }),
    },
  ];

  return (
    <FloatingFormItem
      label={label}
      name={fieldName}
      initialValue={initialValue}
      getValueFromEvent={removeMaskFromEvent}
      rules={rules}
    >
      <MaskedInput
        className="ant-input"
        mask={mask}
        onChange={onChange}
        ref={maskRef}
      />
    </FloatingFormItem>
  );
};

export default NcmFormField;
